// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outer-style[data-v-73e090a0] {\n  height: calc(100% - 50px);\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
